"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ReviewCycleReportRow () {
        return ReviewCycleReportRow;
    },
    get ReviewCycleReportStatus () {
        return ReviewCycleReportStatus;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const ReviewCycleReportStatus = _zod.z.enum([
    "active",
    "scheduled",
    "complete",
    "overdue",
    "closed"
]);
const ReviewCycleReportRow = _zod.z.object({
    _id: _utilsisomorphic.transformObjectId,
    form: _zod.z.object({
        _id: _utilsisomorphic.transformObjectId,
        name: _zod.z.string()
    }),
    subject: _zod.z.object({
        _id: _utilsisomorphic.transformObjectId,
        name: _zod.z.string()
    }),
    status: ReviewCycleReportStatus,
    authorDueDate: _utilsisomorphic.transformDate.nullable(),
    signerDueDate: _utilsisomorphic.transformDate.nullable(),
    visibleToSubject: _zod.z.boolean(),
    redacted: _zod.z.boolean()
});
